import React from "react";

/**
 * R6 A4 — Column presets shown above the individual column checkboxes.
 */
export const COLUMN_PRESETS = {
  sales: {
    label: "Sales view",
    columns: ["dealership", "salesRep", "status", "nextContact", "demo", "actions"],
  },
  contact: {
    label: "Contact view",
    columns: ["dealership", "contact", "email", "mainLine", "notes", "actions"],
  },
  report: {
    label: "Report view",
    columns: ["dealership", "leadSource", "leadType", "status", "products", "created", "actions"],
  },
  compact: {
    label: "Compact",
    columns: ["dealership", "status", "nextContact", "actions"],
  },
};

export default function ColumnPresets({ onApply }) {
  return (
    <div className="r6-column-presets">
      {Object.entries(COLUMN_PRESETS).map(([key, p]) => (
        <button
          key={key}
          type="button"
          className="r6-column-preset"
          onClick={() => onApply?.(p.columns)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}